import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var HomeIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,5l0,-1.506c0,-0.274 0.223,-0.498 0.499,-0.498l1.002,0c0.276,0 0.499,0.224 0.499,0.498l0,3.506l2,2c0,0 0.033,0.999 -1,1l-1,0l0,4c0,0.368 -0.333,0.999 -1,1l-2.006,0c-0.264,0 -0.517,-0.105 -0.703,-0.291c-0.186,-0.186 -0.291,-0.439 -0.291,-0.703c0,-0.615 0,-1.403 0,-2.017c0,-0.262 -0.104,-0.514 -0.29,-0.699c-0.185,-0.186 -0.437,-0.29 -0.699,-0.29c-0.005,0 -0.01,0 -0.016,0c-0.549,0 -0.995,0.446 -0.995,0.995c0,0.617 0,1.407 0,2.022c0,0.543 -0.44,0.983 -0.983,0.983c-0.875,0 -2.017,0 -2.017,0c-0.666,0 -1,-0.632 -1,-1l0,-4l-0.922,0c-1.088,-0.066 -1.078,-1 -1.078,-1l7,-7l3,3Z"
  }));
});
HomeIcon.displayName = 'HomeIcon';
export default HomeIcon;